module.exports = __webpack_public_path__ + "img/u.a5f1cb05.jpg";